<script setup>
  const { data } = defineProps(['data']);
</script>

<!----------------------------------------------------------------------------->

<template>
  <Section autowrap>
    <WrapCenter>
      <ShowAnimation fadeOnly><Quote :data="data" /></ShowAnimation>
    </WrapCenter>
  </Section>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped>
  .center-wrap {
    @include column(3, 10);

    @include break-small {
      @include column(2, 11);
    }

    @include break-phone {
      @include column(1, 12);
    }
  }
</style>
